import { useQuery as useQueryLib } from 'react-query'

const useQuery = useQueryLib

export default useQuery
